import './index.scss';
import '../components/tips-bottom/tips-bottom';
import '../components/ask-doctor/ask-doctor';
import { songbaiSimilar } from '@assets/utils/index';

songbaiSimilar.init();
